/* esm.sh - unhead@2.1.12/client */
export * from "/*unhead@2.1.12/esnext/client.mjs";
